export default __webpack_public_path__ + "static/media/screen2.e3d60ae4.png";